import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskMaintenanceGeneralIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M20.5871 2.03576C20.6213 2.0192 20.6578 2.00817 20.6951 2.00344V2.00183C20.7911 1.99159 20.8871 2.02469 20.9554 2.09248L21.9062 3.03993C22.003 3.13531 22.0276 3.28192 21.9673 3.40332L20.3784 6.55706C20.3245 6.66425 20.2149 6.73204 20.0951 6.73204H18.9562L14.8291 11.0676L13.1109 9.35952L17.238 5.02395V3.89283C17.238 3.77302 17.3071 3.66425 17.4142 3.61065L20.5871 2.03576ZM8.51195 12.2656C8.57067 12.2073 8.64924 12.1742 8.73257 12.1726C8.81828 12.1718 8.90167 12.2049 8.96199 12.2656L11.5 14.7887C11.623 14.9117 11.623 15.1103 11.5 15.2333L10.7722 15.9561L7.7834 12.9892L8.51195 12.2656ZM3.62792 17.2811L7.33577 13.4346L10.3231 16.4024L6.61605 20.2481C5.75481 21.1034 4.3795 21.1539 3.54777 20.3278C2.71682 19.5017 2.76682 18.1364 3.62792 17.2811ZM10.3159 3.41459C8.91625 2.02434 6.87651 1.66057 5.13841 2.31562L7.6542 4.81447C8.43556 5.58983 8.43556 6.83865 7.6542 7.61476C6.87359 8.39086 5.61629 8.39086 4.83493 7.61476L2.31869 5.11546C1.65759 6.84224 2.02449 8.86885 3.42456 10.2595C4.88525 11.7112 7.04338 12.0481 8.82852 11.2712L18.1028 20.483C18.7967 21.1723 19.9147 21.1723 20.6087 20.483C21.3026 19.7938 21.3026 18.6833 20.6087 17.9941L11.3343 8.78216C12.1157 7.00984 11.7765 4.86541 10.3159 3.41459Z'
                fill='currentColor'
            />
        </>
    ),
})

TaskMaintenanceGeneralIcon.displayName = 'TaskMaintenanceGeneralIcon'
